import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=594b8b62&scoped=true&"
import script from "./AddArea.vue?vue&type=script&lang=js&"
export * from "./AddArea.vue?vue&type=script&lang=js&"
import style0 from "./AddArea.vue?vue&type=style&index=0&id=594b8b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b8b62",
  null
  
)

export default component.exports